import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeDataChangeRequest  {
    _originalTypeClassName = "zERP.BO.EmployeeDataChangeRequest";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeDataChangeRequest.translate = translateService;
}
this.Id = null;
this.Email = null;
this.Status = null;
this.DateRequested = null;
this.DateCompleted = null;
this.PhoneNumber = null;
this.DocumentId = null;
this.PassportId = null;
this.DocumentAuthority = null;
this.DocumentIssueDate = null;
this.DocumentExpirationDate = null;
this.IBAN = null;
this.TaxNumber = null;
this.Gender = null;
this.FamilyStatus = null;
this.FirstName = null;
this.LastName = null;
this.MotherName = null;
this.MotherSurname = null;
this.FatherName = null;
this.FatherSurname = null;
this.DateOfBirth = null;
this.PlaceOfBirth = null;
this.SpouseName = null;
this.ChildrenCount = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Email:any;
Status:any;
DateRequested:any;
DateCompleted:any;
PhoneNumber:any;
DocumentId:any;
PassportId:any;
DocumentAuthority:any;
DocumentIssueDate:any;
DocumentExpirationDate:any;
IBAN:any;
TaxNumber:any;
Gender:any;
FamilyStatus:any;
FirstName:any;
LastName:any;
MotherName:any;
MotherSurname:any;
FatherName:any;
FatherSurname:any;
DateOfBirth:any;
PlaceOfBirth:any;
SpouseName:any;
ChildrenCount:any;
Employee:any;
Address:any;
Citizenship:any;
Nationality:any;
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
}
}
static setAddress = ($this, value) => {
var oldValue = $this.Address;
$this.Address = value;
if (value != null) {
}
}
static setCitizenship = ($this, value) => {
var oldValue = $this.Citizenship;
$this.Citizenship = value;
if (value != null) {
}
}
static setNationality = ($this, value) => {
var oldValue = $this.Nationality;
$this.Nationality = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}